import { Spin } from "antd";

import styles from "./Loader.module.css";

const Loader = () => {
  return (
    <Spin size="large">
      <span className={`${styles.loaderText} xl strong`}>Carregant tasca...</span>
    </Spin>
  );
};

export default Loader;
